// src/app/components/MaintenanceWrapper.jsx
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import MaintenancePage from '../views/maintenance/MaintenancePage';
import MaintenanceService from '../services/MaintenanceService';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const MaintenanceWrapper = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [maintenanceStatus, setMaintenanceStatus] = useState({ inMaintenance: false, data: null });
  const location = useLocation();
  
  // Check if current path is an admin route
  const isAdminRoute = location.pathname.startsWith('/admin');

  // Initial check for maintenance status
  useEffect(() => {
    const checkMaintenanceStatus = async () => {
      try {
        setLoading(true);
        const status = await MaintenanceService.checkMaintenanceStatus();
        setMaintenanceStatus(status.body || { inMaintenance: false, data: null });
      } catch (error) {
        console.error('Error checking maintenance status:', error);
        // Default to not in maintenance mode in case of errors
        setMaintenanceStatus({ inMaintenance: false, data: null });
      } finally {
        setLoading(false);
      }
    };

    // Perform initial check
    checkMaintenanceStatus();
  }, []);
  
  // Only set up polling if currently in maintenance mode
  useEffect(() => {
    let intervalId = null;
    
    // Only set up polling interval if in maintenance mode
    if (maintenanceStatus.inMaintenance) {
      const checkMaintenanceStatus = async () => {
        try {
          const status = await MaintenanceService.checkMaintenanceStatus();
          setMaintenanceStatus(status.body || { inMaintenance: false, data: null });
        } catch (error) {
          console.error('Error checking maintenance status:', error);
        }
      };
      
      // Set up polling (30 seconds)
      intervalId = setInterval(checkMaintenanceStatus, 5000);
      console.log('Maintenance polling started');
    }
    
    // Clean up interval when component unmounts or maintenance status changes
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
        console.log('Maintenance polling stopped');
      }
    };
  }, [maintenanceStatus.inMaintenance]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // If system is in maintenance mode and NOT an admin route, display the maintenance page
  if (maintenanceStatus.inMaintenance && !isAdminRoute) {
    return <MaintenancePage maintenanceData={maintenanceStatus.data} />;
  }

  // Otherwise, render children normally
  return children;
};

export default MaintenanceWrapper;
